import { Trans } from '@lingui/react/macro';

import { LinkButton } from '@/components/buttons';
import { Results } from '@/components/Results';
import { Link } from '@/components/typography';
import { ROUTES } from '@/router';

const CampaignOverviewNoData = () => {
  return (
    <Results
      extra={
        <LinkButton variant="primary" to={ROUTES.integrationByCategory()}>
          <Trans>Connect Vendors</Trans>
        </LinkButton>
      }
      subtitle={
        <Trans>
          Campaign reporting requires a connection to your ad vendors. Please visit our Integrations
          page and connect your vendors.{' '}
          <Link to={ROUTES.integrationByCategory()} color="static-grey">
            Learn more
          </Link>
        </Trans>
      }
    />
  );
};

export default CampaignOverviewNoData;
